import { TTemplate } from "~/types/template";
import { baseService } from "../base";
import { PaginationParams, PaginationResponse } from "../type";
import { CreateRuleParams, CreateTemplateParams } from "./template.types";
import { TRule } from "~/types/rule";

export const templateServices = {
  getTemplates: async (params?: PaginationParams) => {
    const { data } = await baseService.get<PaginationResponse<TTemplate>>(
      "/templates",
      {
        params,
      }
    );
    return data;
  },

  getTemplate: async (templateId: string) => {
    const { data } = await baseService.get<TTemplate>(
      `/templates/${templateId}`
    );
    return data;
  },

  createTemplate: async (body: CreateTemplateParams) => {
    const { data } = await baseService.post("/templates", body);
    return data;
  },

  updateTemplate: async ({
    templateId,
    body,
  }: {
    templateId: string;
    body: CreateTemplateParams;
  }) => {
    const { data } = await baseService.patch(`/templates/${templateId}`, body);
    return data;
  },

  deleteTemplate: async (templateId: string) => {
    const { data } = await baseService.delete(`/templates/${templateId}`);
    return data;
  },

  getRules: async (params?: PaginationParams) => {
    const { data } = await baseService.get<PaginationResponse<TRule>>(
      `/rules`,
      {
        params,
      }
    );
    return data;
  },

  createRule: async (body: CreateRuleParams) => {
    const { data } = await baseService.post("/rules", body);
    return data;
  },

  getRule: async (ruleId: string) => {
    const { data } = await baseService.get<TRule>(`/rules/${ruleId}`);
    return data;
  },

  updateRule: async ({
    ruleId,
    body,
  }: {
    ruleId: string;
    body: CreateRuleParams;
  }) => {
    const { data } = await baseService.patch(`/rules/${ruleId}`, body);
    return data;
  },

  deleteRule: async (ruleId: string) => {
    const { data } = await baseService.delete(`/rules/${ruleId}`);
    return data;
  },
};
